import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { UserIcon, MailIcon, PhoneIcon, CheckCircleIcon, AlertCircleIcon } from 'lucide-react';
const WEBHOOK_URL = 'https://services.leadconnectorhq.com/hooks/VPeOQro95PyIFiaEYd4a/webhook-trigger/a7ce68e9-61b2-46de-b2d7-cfb8323eb83d';
interface FormState {
  name: string;
  email: string;
  whatsapp: string;
}
export function LeadCaptureForm() {
  const [form, setForm] = useState<FormState>({
    name: '',
    email: '',
    whatsapp: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (!form.name || !form.email || !form.whatsapp) return;
    setLoading(true);
    setError(null);
    try {
      await fetch(WEBHOOK_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        mode: 'no-cors',
        body: new URLSearchParams({
          name: form.name,
          email: form.email,
          phone: form.whatsapp
        })
      });
      // no-cors means we can't read the response, so we assume success
      setSubmitted(true);
    } catch (err) {
      setError('Hubo un problema al enviar tu registro. Por favor intenta de nuevo.');
    } finally {
      setLoading(false);
    }
  }
  return <motion.div initial={{
    opacity: 0,
    scale: 0.95
  }} animate={{
    opacity: 1,
    scale: 1
  }} transition={{
    duration: 0.6,
    ease: 'easeOut',
    delay: 0.3
  }} className="glass-cyan" style={{
    padding: '24px 20px',
    width: '100%',
    maxWidth: '440px'
  }} data-id="element-1">
      <AnimatePresence mode="wait" data-id="element-2">
        {submitted ? <motion.div key="success" initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} exit={{
        opacity: 0
      }} style={{
        textAlign: 'center',
        padding: '24px 0'
      }} data-id="element-3">
            <div style={{
          marginBottom: '16px'
        }} data-id="element-4">
              <CheckCircleIcon size={56} color="var(--color-cyan)" style={{
            margin: '0 auto'
          }} data-id="element-5" />
            </div>
            <h3 style={{
          fontFamily: 'Poppins, sans-serif',
          fontWeight: 900,
          fontSize: '22px',
          color: 'white',
          marginBottom: '8px'
        }} data-id="element-6">
              ¡Tu lugar está reservado! 🎉
            </h3>
            <p style={{
          color: '#a0a0b0',
          fontSize: '14px',
          fontFamily: 'Inter, sans-serif',
          lineHeight: 1.6
        }} data-id="element-7">
              Revisa tu correo electrónico. Te enviaremos los detalles del
              masterclass en los próximos minutos.
            </p>
            <div style={{
          marginTop: '20px',
          background: 'rgba(0,242,234,0.08)',
          border: '1px solid rgba(0,242,234,0.2)',
          borderRadius: '12px',
          padding: '12px 16px',
          color: 'var(--color-cyan)',
          fontSize: '13px',
          fontFamily: 'Inter, sans-serif',
          fontWeight: 600
        }} data-id="element-8">
              📅 Revisa también tu WhatsApp para el recordatorio
            </div>
          </motion.div> : <motion.div key="form" initial={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} data-id="element-9">
            {/* Header */}
            <div style={{
          textAlign: 'center',
          marginBottom: '20px'
        }} data-id="element-10">
              <div style={{
            display: 'inline-block',
            background: 'rgba(24,163,159,0.1)',
            border: '1px solid rgba(24,163,159,0.35)',
            borderRadius: '8px',
            padding: '4px 12px',
            marginBottom: '10px'
          }} data-id="element-11">
                <span style={{
              color: 'var(--color-teal)',
              fontSize: '11px',
              fontWeight: 700,
              letterSpacing: '0.1em',
              fontFamily: 'Poppins, sans-serif'
            }} data-id="element-12">
                  🎁 RESERVA TU LUGAR GRATIS
                </span>
              </div>
              <h3 style={{
            fontFamily: 'Poppins, sans-serif',
            fontWeight: 900,
            fontSize: '20px',
            color: 'white',
            marginBottom: '6px',
            lineHeight: 1.3
          }} data-id="element-13">
                Accede al Masterclass en Vivo
              </h3>
              <p style={{
            color: '#a0a0b0',
            fontSize: '13px',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-14">
                Aprende el sistema completo + grabación exclusiva
              </p>
            </div>

            {/* Divider */}
            <div style={{
          height: '1px',
          background: 'rgba(24,163,159,0.2)',
          marginBottom: '20px'
        }} data-id="element-15" />

            {/* Form */}
            <form onSubmit={handleSubmit} style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '14px'
        }} data-id="element-16">
              {/* Name */}
              <div style={{
            position: 'relative'
          }} data-id="element-17">
                <div style={{
              position: 'absolute',
              left: '14px',
              top: '50%',
              transform: 'translateY(-50%)',
              zIndex: 1
            }} data-id="element-18">
                  <UserIcon size={16} color="#6b6b80" data-id="element-19" />
                </div>
                <input className="input-glass" type="text" placeholder="Tu nombre completo" value={form.name} onChange={e => setForm(f => ({
              ...f,
              name: e.target.value
            }))} required data-id="element-20" />
              </div>

              {/* Email */}
              <div style={{
            position: 'relative'
          }} data-id="element-21">
                <div style={{
              position: 'absolute',
              left: '14px',
              top: '50%',
              transform: 'translateY(-50%)',
              zIndex: 1
            }} data-id="element-22">
                  <MailIcon size={16} color="#6b6b80" data-id="element-23" />
                </div>
                <input className="input-glass" type="email" placeholder="tu@email.com" value={form.email} onChange={e => setForm(f => ({
              ...f,
              email: e.target.value
            }))} required data-id="element-24" />
              </div>

              {/* WhatsApp */}
              <div style={{
            position: 'relative'
          }} data-id="element-25">
                <div style={{
              position: 'absolute',
              left: '14px',
              top: '50%',
              transform: 'translateY(-50%)',
              zIndex: 1
            }} data-id="element-26">
                  <PhoneIcon size={16} color="#6b6b80" data-id="element-27" />
                </div>
                <input className="input-glass" type="tel" placeholder="+1 (555) 000-0000" value={form.whatsapp} onChange={e => setForm(f => ({
              ...f,
              whatsapp: e.target.value
            }))} required data-id="element-28" />
              </div>

              {/* CTA Button */}
              <motion.button type="submit" className="btn-cta" disabled={loading} animate={loading ? {} : {
            scale: [1, 1.03, 1]
          }} transition={{
            duration: 2,
            repeat: Infinity,
            ease: 'easeInOut'
          }} style={{
            marginTop: '4px',
            opacity: loading ? 0.7 : 1,
            cursor: loading ? 'not-allowed' : 'pointer'
          }} data-id="element-29">
                {loading ? '⏳ Enviando...' : '🚀 QUIERO MI LUGAR GRATIS →'}
              </motion.button>

              {/* Error message */}
              {error && <div style={{
            display: 'flex',
            alignItems: 'flex-start',
            gap: '8px',
            background: 'rgba(242,42,114,0.1)',
            border: '1px solid rgba(242,42,114,0.3)',
            borderRadius: '10px',
            padding: '10px 14px',
            marginTop: '4px'
          }} data-id="element-30">
                  <AlertCircleIcon size={16} color="var(--color-pink)" style={{
              flexShrink: 0,
              marginTop: '1px'
            }} data-id="element-31" />
                  <span style={{
              color: 'var(--color-pink)',
              fontSize: '13px',
              fontFamily: 'Inter, sans-serif',
              lineHeight: 1.5
            }} data-id="element-32">
                    {error}
                  </span>
                </div>}
            </form>

            {/* Trust */}

            {/* Social proof mini */}
            <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '8px',
          marginTop: '14px'
        }} data-id="element-33">
              <div style={{
            display: 'flex'
          }} data-id="element-34">
                {['MR', 'CL', 'AP', 'JG'].map((initials, i) => <div key={initials} style={{
              width: '28px',
              height: '28px',
              borderRadius: '50%',
              background: ['#18a39f', '#f22a72', '#ffe222', '#18a39f'][i],
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '9px',
              fontWeight: 700,
              color: i === 2 ? '#0a0a0f' : 'white',
              marginLeft: i === 0 ? 0 : '-8px',
              border: '2px solid #0a0a0f',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-35">
                    {initials}
                  </div>)}
              </div>
              <span style={{
            color: '#a0a0b0',
            fontSize: '12px',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-36">
                <strong style={{
              color: 'white'
            }} data-id="element-37">
                  2,400+
                </strong>{' '}
                ya registrados
              </span>
            </div>
          </motion.div>}
      </AnimatePresence>
    </motion.div>;
}